<template>
        <button :type="buttonType" :class="['secondary-button', 'd-flex', 'gap-2', 'align-items-center', {'mode-1': mode == 1}]" :style="[{'max-width': buttonWidth}, {'padding-block': paddingY}, {'padding-inline': paddingX}]">
        <img v-if="showIcon" src="../assets/images/secondaryButtonImage.svg" alt="plusButton">
        <slot name="content">

        </slot>
    </button>
</template>
<script>
export default {
    props: {
        buttonType: {
            type: String,
            default: "button"
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        mode: {
            type: Number,
            default: 0,
        },
        buttonWidth: {
            type: String,
            default: "237px"
        },
        paddingY: {
            type: String,
            default: "13px"
        },
        paddingX: {
            type: String,
            default: "22px"
        }
    }
}
</script>
<style scoped>
.secondary-button{
    background-color: var(--middle-green);
    border-radius: 0.3em;
    border: 2px solid transparent;
    color: var(--secondary-background-color);
    width: 100%;
    transition: all 0.3s ease-out;
    text-align: center;
}
.secondary-button.mode-1{
    border: 2px solid var(--middle-green);
    background-color: inherit;
    color: var(--middle-green);
}
</style>